import type { ReactNode } from "react";
import { useEffect, useRef } from "react";
import { Animated } from "react-native";

export const Modal = ({
  children,
  visible = true,
  transparent,
  faded,
}: {
  children: ReactNode;
  visible?: boolean;
  transparent?: boolean;
  faded?: boolean;
}) => {
  const opacity = useRef(new Animated.Value(visible ? 1 : 0)).current;

  const getBackgroundColor = () => {
    if (transparent) {
      return "transparent";
    }

    if (faded) {
      return "rgba(0,0,0,0.75)";
    }

    return "#ffffff";
  };

  useEffect(() => {
    Animated.spring(opacity, {
      toValue: visible ? 1 : 0,
      tension: 60,
      useNativeDriver: false,
    }).start();
  }, [visible, opacity]);

  return (
    <Animated.View
      style={{
        backgroundColor: getBackgroundColor(),
        bottom: 0,
        left: 0,
        justifyContent: "center",
        opacity,
        padding: 16,
        position: "absolute",
        right: 0,
        top: 0,
        zIndex: 22500,
      }}
      pointerEvents={visible ? "auto" : "none"}
    >
      {children}
    </Animated.View>
  );
};
